import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useIntl } from "react-intl";
import { updateDepotPrices } from "../../../_redux/depots/depotsCrud";

const DepotPriceModal = ({ dialog, setDialog, editedPrices,depot_id,setSnack }) => {
  const intl = useIntl();

  // Always copy props into local state
  const [prices, setPrices] = useState([]);

  useEffect(() => {
    // Deep copy to avoid mutating props
    const copied = editedPrices.map((p) => ({ ...p }));
    setPrices(copied);
  }, [editedPrices]);

  const handleChange = (index, value) => {
    const updated = prices.map((item, i) =>
      i === index ? { ...item, unit_amount: Number(value) } : item
    );
    setPrices(updated);
  };

  const handlePriceSubmit = async () => {
    try {
      let data = {
        prices: prices,
        depot_id: depot_id
      };
      await updateDepotPrices(data); // API call
      await setSnack({ call: true, type: "success", message: "Prices Updated." });
      setDialog(false);
    } catch (error) {
      setSnack({ call: true, type: "danger", message: "Something went wrong!" });
      console.error("Failed to update depot prices:", error);
    }
  };


  return (
    <Modal show={dialog.modal} aria-labelledby="example-modal-sizes-title-lg">
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">Activate</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-200 rounded-lg">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-6 py-3 text-left text-sm font-medium text-gray-600 border-b">
                  Pod (Units)
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium text-gray-600 border-b">
                  Price per Unit (&pound;/mo)
                </th>
              </tr>
            </thead>
            <tbody>
              {prices.map((item, index) => (
                <tr
                  key={index}
                  className="hover:bg-gray-50 transition-colors duration-150"
                >
                  <td className="px-6 py-3 text-gray-800 border-b">
                    {item.tier_end_unit || `${index + 1}+`}
                  </td>
                  <td className="px-6 py-3 border-b">
                    <input
                      type="number"
                      value={item.unit_amount}
                      onChange={(e) => handleChange(index, e.target.value)}
                      className="w-28 border rounded-lg px-3 py-1 text-gray-700 focus:ring focus:ring-indigo-200 focus:border-indigo-400 outline-none"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={() => setDialog(false)}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={handlePriceSubmit}
            className="btn btn-delete btn-elevate"
          >
            Submit
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default DepotPriceModal;
